<div class="chat-box question" >

  <div class="profile-container">
    <div class="profile">
    </div>
  </div>

  <div class="chat-content">

    <p><span class="bold">I'm Ollie!</span> Great coaching is driven by great questions. 
      I'll help you generate tailored coaching questions for situations and people, 
      using the breakthrough <span class="bold">RESPECT Coaching Styles™ </span>Framework. </p>

    <p>Example situations: </p>

    <p class="example-situations">Give me questions for someone who isn't motivated and is underperforming.</p>
    <p class="example-situations">Give me questions for a team member who struggling with confidence.</p>
  </div>

</div>